import {Pipe, PipeTransform} from '@angular/core';
import {DateRange, DateTime} from 'ts-tooling';

export interface IValidity {
  ValidFrom: Date | string;
  ValidTo: Date | string;
}

@Pipe({
  name: 'fieldIsActive',
})
export class FieldIsActivePipe implements PipeTransform {
  transform(value: IValidity, args: [number, number]): boolean {
    if (!value) {
      return true;
    }
    const year = args[0] + args[1];
    if (year > 2) {
      const vf = typeof value.ValidFrom === typeof '' ?
        DateTime.FromISOString(value.ValidFrom as string, 'UTC') :
        new DateTime('UTC', (value.ValidFrom as Date).getFullYear(), (value.ValidFrom as Date).getMonth() + 1, (value.ValidFrom as Date).getDate(),
          (value.ValidFrom as Date).getHours(), (value.ValidFrom as Date).getMinutes(), (value.ValidFrom as Date).getSeconds());
      const vt = typeof value.ValidTo === typeof '' ?
        DateTime.FromISOString(value.ValidTo as string, 'UTC') :
        new DateTime('UTC', (value.ValidTo as Date).getFullYear(), (value.ValidTo as Date).getMonth() + 1, (value.ValidTo as Date).getDate(),
          (value.ValidTo as Date).getHours(), (value.ValidTo as Date).getMinutes(), (value.ValidTo as Date).getSeconds());
      const fieldInterval = new DateRange(vf, vt);
      const yearInterval = new DateRange(
        new DateTime('UTC', year - 1, 8, 1, 0, 0, 0, 0),
        new DateTime('UTC', year, 7, 31, 23, 59, 59, 0)
      );
      return yearInterval.Overlaps(fieldInterval);
    }
    return true;
  }
}
